import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { C } from '../theme';
import { Icon } from '../icons';

type ToastCtx = (message: string) => void;
const Ctx = createContext<ToastCtx>(() => {});

/** Wrap the app once; call `useToast()` anywhere to fire the bottom toast. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<string | null>(null);
  const notify = useCallback((s: string) => setToast(s), []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 2600);
    return () => clearTimeout(t);
  }, [toast]);

  return (
    <Ctx.Provider value={notify}>
      {children}
      {toast && (
        <div
          role="status"
          style={{
            position: 'fixed',
            left: '50%',
            bottom: 26,
            transform: 'translateX(-50%)',
            background: C.ink,
            color: '#fff',
            padding: '11px 18px',
            borderRadius: 11,
            fontSize: 13.5,
            fontWeight: 500,
            boxShadow: '0 10px 30px rgba(0,0,0,.28)',
            display: 'flex',
            alignItems: 'center',
            gap: 9,
            zIndex: 100,
            maxWidth: 'calc(100vw - 32px)',
          }}
        >
          <span
            style={{
              width: 18,
              height: 18,
              borderRadius: 999,
              background: C.hi,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 'none',
            }}
          >
            <Icon n="check" size={12} color="#fff" />
          </span>
          {toast}
        </div>
      )}
    </Ctx.Provider>
  );
}

export function useToast(): ToastCtx {
  return useContext(Ctx);
}
